import { createContext } from 'react';

export const UserNotificationContext = createContext(null);
